import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../../../Layout/Layout";
import { useState, useEffect } from "react";
import BudgetCard from "../Charts/Budget/BudgetCard";
import BudgetModal from "./BudgetModal";
import ItemServiceV2 from "../../../services/ap_auto_appCommonService";
import { useNavigate } from "react-router-dom";
import AP_AUTOConstants from "../../../common/AP_AUTOConstants";
const BudgetCardsShow = () => {
  const [modalFuelShowStatus, setmodalFuelShowStatus] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const showFuelModal = () => setmodalFuelShowStatus(true);
  const hideModalStatus = () => setmodalFuelShowStatus(false);
  const navigate = useNavigate();

  const getBudgetCards = () => {
    setLoading(true);

    let payload = {
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {},
    };

    ItemServiceV2.budgetCards(payload).then((res) => {
      if (res?.status === 200) {
        const cleanData = (res?.data || []).map((item, index) => ({
          documentNumber:
            item.documentNumber || item.budgetNr || `DOC-${index + 1}`,
          title: item.title || "Unknown",
          type:
            item.type && !item.type.includes("undefined")
              ? item.type
              : "Not Available",
          limit: Number(item.limit) || 0,
          spent: Number(item.spent) || 0,
          available: Number(item.available) || 0,
        }));
        setData(cleanData);
      } else {
        console.error("Failed to fetch budgets");
      }

      setLoading(false);
    });
  };

  useEffect(() => {
    getBudgetCards();
  }, []);

  const listPage = () => {
    navigate(AP_AUTOConstants.BUDGET_LIST);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />

      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row className="align-items-center">
              <Col xs={12} md={8}>
                <h2 className="mainTitle">Budget</h2>
                <p className="subText">Lists Budget and details</p>
              </Col>

              {/* <Col xs={12} md={4} className="text-end">
                <button className="btn btn-md" onClick={showFuelModal}>
                  <i className="bi bi-receipt me-1"></i>
                  Create
                </button>
              </Col>
              <Col xs={12} md={4} className="text-end">
                <button className="btn btn-md" onClick={listPage}>
                  <i className="bi bi-receipt me-1"></i>
                  List
                </button>
              </Col> */}
              <Col xs={12} md={4} className="text-end">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  <button className="btn btn-primary" onClick={showFuelModal}>
                    <i className="bi bi-plus-circle me-1"></i>
                    Create
                  </button>

                  <button
                    className="btn btn-outline-secondary"
                    onClick={listPage}
                  >
                    <i className="bi bi-list-ul me-1"></i>
                    List
                  </button>
                </div>
              </Col>
            </Row>
            {loading && <p>Loading budgets...</p>}
            {!loading && data.length === 0 && <p>No budgets found</p>}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill,340px)",
                gap: "10px",
                marginTop: "10px",
              }}
            >
              {data.map((item, index) => (
                <BudgetCard key={index} {...item} />
              ))}
            </div>
          </div>
        </Col>
      </Row>
      <BudgetModal
        show={modalFuelShowStatus}
        onHide={hideModalStatus}
        refreshData={getBudgetCards}
      />
    </main>
  );
};

export default BudgetCardsShow;
